import { Component, Input } from '@angular/core';
import { NavController } from '@ionic/angular';
import { ApiV1Job, ApiV1Shift, DashboardFeedItemTodaysJob } from '@bluecrew/crew-member-backend-angular-client';
import { openGoogleMaps } from 'src/app/util/google-maps-utils';
import { getTextStyle } from 'src/app/util/style-util';

@Component({
  selector: 'app-todays-shift',
  templateUrl: './todays-shift.component.html',
  styleUrls: ['./todays-shift.component.scss'],
})
export class TodaysShiftComponent {

  todaysJobInfo: ApiV1Job;
  todaysShiftInfo: ApiV1Shift;

  private _feedItem: DashboardFeedItemTodaysJob;

  @Input()
  get feedItem(): DashboardFeedItemTodaysJob { return this._feedItem; }
  set feedItem(feedItem: DashboardFeedItemTodaysJob) {
    this._feedItem = feedItem;
    this.todaysJobInfo = feedItem.todaysJob;
    this.todaysShiftInfo = feedItem.todaysShift;
  }

  constructor(
              private navCtrl: NavController,
  ) { }

  fallbackWorkplaceImg = ($event: ErrorEvent) => {
    ($event.target as HTMLImageElement).src = '/assets/icons/building.svg';
  };

  getJobWageComponents(wage: number) {
    return wage?.toFixed(2).split('.');
  }

  async onGetDirections() {
    openGoogleMaps(this.todaysJobInfo);
  }

  onClockInOutClick() {
    this.navCtrl.navigateForward(this._feedItem.cta.url);
  }

  getCtaText() {
    return this._feedItem.cta.text;
  }

  getTextStyle = getTextStyle;
}

